import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';

export default function AdminDashboard({ user, onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50">
      <Navbar user={user} onLogout={onLogout} />

      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Admin Dashboard</h1>
          <p className="text-xl text-gray-600">Manage your volleyball club</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div
            data-testid="manage-games-card"
            onClick={() => navigate('/admin/games')}
            className="bg-white rounded-2xl shadow-lg p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-orange-500"
          >
            <div className="text-6xl mb-4">🏐</div>
            <h3 className="text-3xl font-bold mb-3 text-gray-900">Manage Games</h3>
            <p className="text-gray-600 text-lg">Create, edit, and manage volleyball games</p>
          </div>

          <div
            data-testid="manage-users-card"
            onClick={() => navigate('/admin/users')}
            className="bg-white rounded-2xl shadow-lg p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-blue-500"
          >
            <div className="text-6xl mb-4">👥</div>
            <h3 className="text-3xl font-bold mb-3 text-gray-900">Manage Users</h3>
            <p className="text-gray-600 text-lg">View and manage club members</p>
          </div>

          <div
            onClick={() => navigate('/admin/legal')}
            className="bg-white rounded-2xl shadow-lg p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-green-500"
          >
            <div className="text-6xl mb-4">📄</div>
            <h3 className="text-3xl font-bold mb-3 text-gray-900">Legal Documents</h3>
            <p className="text-gray-600 text-lg">Edit Terms & Privacy Policy</p>
          </div>

          <div
            onClick={() => navigate('/admin/about')}
            className="bg-white rounded-2xl shadow-lg p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-purple-500"
          >
            <div className="text-6xl mb-4">✨</div>
            <h3 className="text-3xl font-bold mb-3 text-gray-900">Edit About Page</h3>
            <p className="text-gray-600 text-lg">Update About page content & media</p>
          </div>

          <div
            onClick={() => navigate('/admin/audit-logs')}
            className="bg-white rounded-2xl shadow-lg p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-indigo-500"
          >
            <div className="text-6xl mb-4">📋</div>
            <h3 className="text-3xl font-bold mb-3 text-gray-900">Audit Logs</h3>
            <p className="text-gray-600 text-lg">Complete activity history & tracking</p>
          </div>

          <div
            onClick={() => navigate('/admin/ratings')}
            className="bg-white rounded-2xl shadow-lg p-8 hover-lift cursor-pointer border-2 border-transparent hover:border-yellow-500"
          >
            <div className="text-6xl mb-4">⭐</div>
            <h3 className="text-3xl font-bold mb-3 text-gray-900">Rating Management</h3>
            <p className="text-gray-600 text-lg">View, edit & delete player ratings</p>
          </div>
        </div>
      </div>
    </div>
  );
}
